import type { CategoryBadgeBlock as CategoryBadgeBlockType } from '@/shared/types/blocks';
import { Badge } from '@/shared/ui/badge';

/**
 * CategoryBadgeBlock - 카테고리 뱃지
 *
 * Figma 디자인 기준:
 * - 라벨: label-small-b (14px Bold), label-neutral
 * - 배경: white 80% opacity
 * - 테두리: label-disabled (#e8ebed)
 * - 패딩: px-3 (12px) py-1 (4px)
 * - 라운드: 6px
 */
export function CategoryBadgeBlock({ label }: Omit<CategoryBadgeBlockType, 'type' | 'id'>) {
  return (
    <Badge
      variant="outline"
      className="label-small-b rounded-[6px] border border-label-disabled bg-white/80 text-label-neutral hover:bg-white/80 truncate px-3 py-1"
    >
      {label}
    </Badge>
  );
}
